var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"notice-bar",attrs:{"no-gutters":""}},[_c('span',{staticClass:"notice-bar__logo"},[_vm._v("NOTICE")]),_vm._v(" "),_c('span',{staticClass:"notice-bar__post-title ml-o-5"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }